import { useStore } from "vuex"
import { computed, onMounted } from 'vue'

export default {
    name: "GroupCard",
    props: {
        content: {
            type: Object,
            default: {},
        }
    },
    setup(props) {
        const store = useStore()

        const groupId = props.content.groupId ?? props.content.id

        const statistics = computed(() => store.state.forum.group_statistics[groupId])
        const memberCount = computed(() => statistics.value?.memberCount)
        const postsCount = computed(() => statistics.value?.postsCount)
        
        onMounted(() => {
            store.dispatch("forum/getGroupStatistics", {
                groupId: groupId
            })
        })

        const getLabel = (labelKey) =>
            store.getters["labels/getLabel"]({
                labelCollection: "GroupCard",
                labelKey,
            })

        return {
            memberCount,
            postsCount,
            getLabel
        }
    }
}